"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitials = getInitials;
/**
 * First and last initial of a name — "Demond Makhubela" becomes "DM".
 *
 * Deliberately capped at two letters: these appear in tight spaces (calendar chips, avatar
 * badges) where a middle name would push a third letter in and cost the title its room.
 */
function getInitials(name) {
    var _a, _b;
    var parts = (name !== null && name !== void 0 ? name : "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) {
        return "";
    }
    var first = (_a = parts[0][0]) !== null && _a !== void 0 ? _a : "";
    var last = parts.length > 1 ? ((_b = parts[parts.length - 1][0]) !== null && _b !== void 0 ? _b : "") : "";
    return "".concat(first).concat(last).toUpperCase();
}
